import { Delta } from '@typewriter/editor';
import { Sprint } from './sprints';


export function dehydrateDeltas(sprint: Sprint) {
  if (!sprint) return sprint;
  const data = { ...sprint };
  Object.keys(data).forEach(key => data[key] && data[key].ops && (data[key] = { ops: data[key].ops }));
  return data;
}

export function hydrateDeltas(data: any) {
  if (!data) return data;
  const sprint = { ...data } as Sprint;
  Object.keys(sprint).forEach(key => sprint[key] && sprint[key].ops && (sprint[key] = new Delta(sprint[key].ops)));
  return sprint;
}
